module.exports = __webpack_public_path__ + "static/media/arrow-triangle-fill-up.2af1b1a9.svg";